import React from 'react';
import { KPMGEmptyTableIcon } from '../../../assets/icons';
import styled from 'styled-components';
import Color from '../../../enums/color';
import Label from '../Label';
import { automationIds } from '../../../constants/automationIds';
const EmptyTableContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  svg {
    width: 95px;
    height: 90px;
  }
  
  span {
    font-family: 'Roboto Bold';
    color: ${Color.JordyBlue};
    font-size: 14px;
  }
`;
const EmptyTable = () => <EmptyTableContainer data-automation-id={automationIds.SHARED.EMPTY_TABLE}>
    <KPMGEmptyTableIcon />
    <Label title='TABLE.NO_ELEMENT_FOUND'/>
  </EmptyTableContainer>;
export default EmptyTable;
